import React, { FC } from "react"
import { Space, Typography } from "antd"
import { PENNY_COLOR } from "../util/Constants"
const { Title } = Typography

export const PennyVibes: FC = () => {
    return (
        <Space direction="vertical" align="center" style={{ width: "100%" }} className="hiddenOnMobile">
            <Title level={2} style={{ color: PENNY_COLOR }}><i>This leaderboard is powered by Penny Vibes.</i></Title>
        </Space>
    )
}